export * from './system-setting-report-photo-not-attaching-penalty-read.slice';
export * from './system-setting-report-photo-not-attaching-penalty-update.slice';
export * from './system-setting-report-writing-delay-penalty-read.slice';
export * from './system-setting-report-writing-delay-penalty-update.slice';
export * from './system-settings-reports.slice';
